module.exports = __webpack_public_path__ + "static/media/no-product.41850e92.png";